/*
 * @description: 
 * @param: 
 * @return: 
 */
// 时间搓格式化
export function formatDate(date, format) {
  let choice = {
    yyyy: date.getFullYear(),
    yy: date
      .getFullYear()
      .toString()
      .slice(-2),
    MM: ('0' + (date.getMonth() + 1)).slice(-2),
    M: date.getMonth() + 1,
    dd: ('0' + date.getDate()).slice(-2),
    d: date.getDate(),
    HH: ('0' + date.getHours()).slice(-2),
    H: date.getHours(),
    hh: ('0' + (date.getHours() % 12)).slice(-2),
    h: date.getHours() % 12,
    mm: ('0' + date.getMinutes()).slice(-2),
    m: date.getMinutes(),
    ss: ('0' + date.getSeconds()).slice(-2),
    s: date.getSeconds(),
    w: ['日', '一', '二', '三', '四', '五', '六'][date.getDay()]
  }
  return format.replace(/[A-z]+/g, function(str) {
    return choice[str]
  })
}

// 时间格式化 yyyy-MM-dd  conts 前几天
export function datainfor(conts = 0) {
  let myDate = new Date()
  myDate.setDate(myDate.getDate() - conts)
  const dt = myDate
  const y = dt.getFullYear()
  const m = (dt.getMonth() + 1 + '').padStart(2, '0')
  const d = (dt.getDate() + '').padStart(2, '0')
  return `${y}-${m}-${d}`
}


/**
 * 比较两个日期大小
 * @param a  yyyy-MM-dd
 * @param b   yyyy-MM-dd
 */
export function sortDate(a, b) {
  const arr1 = a.split('-')
  const arr2 = b.split('-')
  let i = 0
  while (i < arr1.length) {
    if (arr1[i] === arr2[i]) {
      i++
    } else {
      return arr1[i] - arr2[i]
    }
  }
  return false
}
